export const environment = {
  production: true,
  host: '<BACKHOST>',
  keepAlive: {
    pingInterval: 20 * 60 * 1000,
    idleTimeout: 60 * 60 * 1000
  }
};
